export { default as CardRating } from './card-rating';
export type { CardRatingProps } from './card-rating';
